var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type-box"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.type,"subtitle":"SERVICE STATEMENT"}}),_c('agreement',{attrs:{"show":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }